import React, { Fragment, useState, useEffect } from "react";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setOrderObj,
  setAllowedActions,
} from "../../../Redux/Actions/TechAppAction";
import { Button, Modal } from "antd";
import useOrder from "../../../hooks/useOrder";
import FormatHelper from "../../../Helper/FormatHelper";
import lang from "../lang/lang.json";
import { FaRegClock, FaRegUser } from "react-icons/fa";
import { FiCalendar, FiMinusCircle } from "react-icons/fi";
import { IoDocumentTextOutline, IoLocationOutline } from "react-icons/io5";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { toast } from "react-toastify";

const OrderCard = ({ order, index, type, labelColor }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { seenOrder, alertModal } = useOrder();

  const [labelTypeColor, setLabelTypeColor] = useState("#1e5279");

  const [isSeen, setIsSeen] = useState(
    order.seen === 0 && (order?.status_id === 3 || order?.status_id === 16)
      ? false
      : true
  );

  const profileData = useSelector((state) => state.TechAppReducer.profileData);

  const openOrder = (order, actions) => {
    if (isSeen) {
      dispatch(setOrderObj(order));
      dispatch(setAllowedActions(actions));
      navigate("/techapp/view-order");
    }
  };

  useEffect(() => {
    if (order?.assign_type === 1) {
      setLabelTypeColor("#fcc603");
    } else if (order?.assign_type === 2) {
      setLabelTypeColor("#1e5279");
    } else if (order?.assign_type === 3) {
      setLabelTypeColor("#1ab849");
    } else {
      setLabelTypeColor("#1e5279");
    }
  }, []);

  return (
    <div
      onClick={() => {
        if (!localStorage.getItem("auth_from_admin")) {
          openOrder(order, order?.allowedActions.data);
        } else {
          toast.error("شما از پنل ادمین وارد شده اید و دسترسی ندارید.");
        }
      }}
      key={index}
      className="tech-app-orders-container-item"
    >
      {/* order card label */}
      <div
        style={
          order?.assign_type
            ? { backgroundColor: labelTypeColor }
            : {
                backgroundColor: labelColor,
              }
        }
        id={profileData?.available === 0 ? "bg_of" : ""}
        className="tech-app-orders-container-item-title"
      >
        <span id={profileData?.available === 0 ? "text_of" : ""}>
          {order?.assign_type ? (
            <Fragment>
              {order?.assign_type === 1 ? lang.SUGGESTED : ""}
              {order?.assign_type === 2 ? lang.AROUND_AREAS : ""}
              {order?.assign_type === 3 ? lang.SPECIAL : ""}
            </Fragment>
          ) : (
            order?.status_name
          )}
        </span>
      </div>
      {order?.status_id !== 3 || order?.status_id !== 16 ? (
        <div className="tech-app-orders-container-item-detail">
          {/* customer name */}
          {order?.status_id !== 3 && order?.status_id !== 16 ? (
            <div id={profileData?.available === 0 ? "text_of" : ""}>
              <FaRegUser />
              <span>{lang.CUSTOMER_NAME} :</span>
              <span>
                {order?.user.data.first_name} {order?.user.data.last_name}
              </span>
            </div>
          ) : null}
          {/* date time */}
          <div id={profileData?.available === 0 ? "text_of" : ""}>
            <FiCalendar />
            <span>{lang.DATE} :</span>
            <span>{FormatHelper.toPersianString(order?.persian_date)}</span>
          </div>
          {/* address */}
          <div id={profileData?.available === 0 ? "text_of" : ""}>
            <IoLocationOutline />
            <span>{lang.ADDRESS} :</span>
            <span>{order?.address?.data?.location?.data?.title}</span>
          </div>
          {/* order service */}
          <div id={profileData?.available === 0 ? "text_of" : ""}>
            <IoMdInformationCircleOutline />
            <span>{lang.REQUESTED_SERVICE} :</span>
            <span>{order?.service.data.title}</span>
          </div>
          {/* remaining time */}
          {order?.time_to_done_order_text && order?.time_to_done_order > 2 ? (
            <div id={profileData?.available === 0 ? "text_of" : ""}>
              <FaRegClock id={profileData?.available === 0 ? "text_of" : ""} />
              <span></span>
              <span id={profileData?.available === 0 ? "text_of" : ""}>
                {FormatHelper.toPersianString(order?.time_to_done_order_text)}
              </span>
            </div>
          ) : null}
          {order?.time_to_done_order_text &&
          order?.time_to_done_order < 3 &&
          order?.time_to_done_order > -1 ? (
            <div id={profileData?.available === 0 ? "text_of" : ""}>
              <FaRegClock
                id={profileData?.available === 0 ? "text_of" : ""}
                style={{ color: "#fcc603" }}
              />
              <span></span>
              <span
                id={profileData?.available === 0 ? "text_of" : ""}
                style={{ color: "#fcc603" }}
              >
                {FormatHelper.toPersianString(order?.time_to_done_order_text)}
              </span>
            </div>
          ) : null}
          {order?.time_to_done_order_text && order?.time_to_done_order < 0 ? (
            <div id={profileData?.available === 0 ? "text_of" : ""}>
              <FaRegClock
                id={profileData?.available === 0 ? "text_of" : ""}
                style={{ color: "red" }}
              />
              <span></span>
              <span
                id={profileData?.available === 0 ? "text_of" : ""}
                style={{ color: "red" }}
              >
                {FormatHelper.toPersianString(order?.time_to_done_order_text)}
              </span>
            </div>
          ) : null}
          {profileData?.verified === 0 &&
          profileData?.unverified_message?.length > 0 &&
          order?.time_to_done_order < 0 ? (
            <div id={profileData?.available === 0 ? "text_of" : ""}>
              <FiMinusCircle style={{ color: "red" }} />
              <span></span>
              <span
                id={profileData?.available === 0 ? "text_of" : ""}
                style={{ color: "red" }}
              >
                {lang.ORDER_DEACTIVE_PROFILE_MESSAGE}
              </span>
            </div>
          ) : null}
          {/* last note */}
          {order?.notes?.length > 0 && (
            <div id={profileData?.available === 0 ? "text_of" : ""}>
              <IoDocumentTextOutline />
              <span>{lang.LAST_NOTE} :</span>
              <span>
                {order.notes[order.notes.length - 1].note.length < 30
                  ? order.notes[order.notes.length - 1].note
                  : order.notes[order.notes.length - 1].note.substring(0, 30) +
                    "..."}
              </span>
            </div>
          )}
        </div>
      ) : (
        <></>
      )}
      {!isSeen && (
        <div
          onClick={() => {
            if (!localStorage.getItem("auth_from_admin")) {
              setIsSeen(true);
              seenOrder(order.id);
            }
          }}
          className="order-card-seen-order"
          id={profileData?.available === 0 ? "orders_bg_of" : ""}
        >
          <div id={profileData?.available === 0 ? "text_of" : ""}>
            {order?.assign_type === 1 ? lang.SUGGESTED_DESCRIPTION : ""}
            {order?.assign_type === 2 ? lang.AROUND_AREAS_DESCRIPTION : ""}
            {order?.assign_type === 3 ? lang.SPECIAL_DESCRIPTION : ""}
          </div>
          <span>{lang.VIEW_DETAILS}</span>
        </div>
      )}
      {isSeen && (
        <Fragment>
          {/* special badge */}
          {order?.custom_share && (
            <div
              id={profileData?.available === 0 ? "text_of" : ""}
              className="tech-app-orders-container-item-rate"
            >
              <span>{lang.YOUR_SHARE}</span>
              <span>{FormatHelper.toPersianString(order?.custom_share)} ٪</span>
            </div>
          )}
          {/* urgency label */}
          {order?.urgency === 2 && (
            <div
              id={profileData?.available === 0 ? "text_of" : ""}
              className="order-card-urgency-label"
            >
              {lang.INSTANTANEOUS}
            </div>
          )}
        </Fragment>
      )}
      <Modal footer={null} open={alertModal}>
        <div className="order_card_alert_modal">
          <div>{lang.VIEW_ORDER_ALERT_MESSAGE}</div>
          <Button>{lang.UNDERSTOOD}</Button>
        </div>
      </Modal>
    </div>
  );
};
export default OrderCard;
